export default __webpack_public_path__ + "static/media/logo.29fd4a21.png";